import { InputType } from 'src/types'

import { useSheetForMaintenanceHistory } from 'src/features/SheetForMaintenanceHistory/useSheetForMaintenanceHistory'
import { SheetForMaintenanceProps } from 'src/features/SheetForMaintenanceHistory/types'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from 'src/components/shadcn/sheet'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/shadcn/select'
import { Input } from 'src/components/shadcn/input'
import { Button } from 'src/components/shadcn/button'

export const SheetForMaintenanceHistory = ({
  setFilters,
  filters,
  filtersCount,
}: SheetForMaintenanceProps): JSX.Element => {
  const {
    locale,
    filterFields,
    serviceTypeOptions,
    localFilters,
    handleChangeServiceType,
    handleChange,
    onReset,
    onSave,
    setIsOpen,
    isOpen,
  } = useSheetForMaintenanceHistory({ filters, setFilters })

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger>
        <Button className="rounded-[10px] w-[100px]">
          {locale.title} ({filtersCount})
        </Button>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>{locale.title}</SheetTitle>
          <SheetDescription>{locale.description}</SheetDescription>
        </SheetHeader>
        <SheetDescription>
          <div className="space-y-4">
            {filterFields.map(({ key, type, placeholder }) => {
              if (type === InputType.SELECT) {
                return (
                  <div key={key}>
                    <Select
                      onValueChange={handleChangeServiceType}
                      value={localFilters[key] ?? ''}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder={placeholder} />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectGroup>
                          {serviceTypeOptions.map(({ value, placeholder }) => (
                            <SelectItem key={value} value={value}>
                              {placeholder}
                            </SelectItem>
                          ))}
                        </SelectGroup>
                      </SelectContent>
                    </Select>
                  </div>
                )
              }

              return (
                <Input
                  key={key}
                  placeholder={placeholder}
                  type={type}
                  value={localFilters[key] ?? ''}
                  onChange={event => handleChange(event, key, type)}
                />
              )
            })}
          </div>
        </SheetDescription>
        <SheetFooter>
          <div className="mt-5">
            <Button
              variant="outline"
              className="rounded-[10px]"
              onClick={onReset}
            >
              {locale.rest}
            </Button>
            <Button className="rounded-[10px] ml-3" onClick={onSave}>
              {locale.save}
            </Button>
          </div>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
